export const mexicoYucatanProgram = {
  programKey: 'meksyk-karaibskie-oblicza-jukatanu',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Meksyk - Karaibskie oblicza Jukatanu',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Meksyk:',
  stickySubtitle: 'Karaibskie oblicza Jukatanu',

  pageUrl:
    'https://coolturystki.pl/wycieczki/meksyk-karaibskie-oblicza-jukatanu',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/meksyk-jukatan-karaibskie-wybrzeze-mtfk38xy.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/meksyk-jukatan-karaibskie-wybrzeze-mtfk38xy.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Meksyk'],
    continent: 'Ameryka Północna',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-09-01',
  },

  /* Termin o ID 15: 11 - 22 stycznia 2027. */
  tripIds: [15],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '15': {
      pilotId: 'iza',
      group: 'Tylko dla kobiet',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa rozpoczyna podróż na Lotnisku Chopina w Warszawie i leci do Cancún. Możliwe jest również rozpoczęcie podróży w Krakowie, Gdańsku, Wrocławiu, Berlinie lub Pradze.',
        },
        hotel: {
          title: 'Noclegi w dżungli, Izamal i resorcie 5★',
          description:
            'Zakwaterowanie w okolicach Puerto Morelos, w Izamal oraz na Riviera Maya. Pokoje 2-osobowe, śniadania i obiadokolacje oraz pobyt w formule All Inclusive zgodnie z programem.',
        },
      },
    },
  },
}
